import ComponentName from '@Constant/componentName'

const qifei = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/qifei',
    redirect: {
      name: ComponentName.qifei.index
    },
    children: [
      {
        component: () => import('../../views/toolbox/index.vue'),
        path: 'index',
        name: ComponentName.qifei.index,
        auth: '*',
        meta: {
          title: '起飞推荐'
        }
      }
    ]
  }
]

export default qifei
